/* eslint-disable no-unused-vars */
import React, { lazy } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
import { useRole, useRoleGroup } from 'lib/evi-role-action/hoc';

import GuestGuard from '../guards/GuestGuard';
import AuthGuard from '../guards/AuthGuard';
// import AuthorityGuard from '../guards/AuthorityGuard';

import Loadable from './Loadable';

const Routes = () => {
  const [UserRole] = useRole({
    type: 'staff',
    module: 'user',
    controller: 'staff',
    action: [
      'get',
      'get_list',
      'add',
      'update',
      'delete',
      'add_teacher',
      'add_student',
    ],
  });

  const [GroupRole] = useRole({
    type: 'staff',
    module: 'user',
    controller: 'group',
    action: ['get_list', 'get'],
  });

  const [DrpcUserRole] = useRole({
    type: 'staff',
    module: 'drpc_user',
    controller: 'main',
  });

  const [BuilderRole] = useRole({
    type: 'staff',
    module: 'user',
    controller: 'builder',
  });

  const [DocumentRole] = useRole({
    type: 'staff',
    module: 'drpc_course',
    controller: 'document',
  });

  const [MerchantM] = useRoleGroup({
    type: 'staff',
    group: 'STAFF_ROLE_SUB_MERCHANT',
  });

  const [BuilderM] = useRoleGroup({
    type: 'staff',
    group: 'STAFF_BUILDER_ADMIN',
  });

  const [ContractM] = useRoleGroup({
    type: 'staff',
    group: 'STAFF_ROLE_CONTRACT_ADMIN',
  });

  return useRoutes([
    {
      path: '/',
      children: [
        { element: <Navigate to="/login" replace /> },
        {
          path: 'login',
          element: (
            <GuestGuard>
              <Login />
            </GuestGuard>
          ),
        },
        // {
        //   path: 'merchant',
        //   element: (
        //     <GuestGuard>
        //       <Merchant />
        //     </GuestGuard>
        //   ),
        // },
        // {
        //   path: 'register',
        //   element: (
        //     <GuestGuard>
        //       <Register />
        //     </GuestGuard>
        //   )
        // },
      ],
    },
    {
      path: 'dashboard',
      element: (
        <AuthGuard>
          <DashboardLayout />
        </AuthGuard>
      ),
      children: [
        { element: <Navigate to="/dashboard/apply-for" replace /> },
        { path: 'app', element: <Dashboard /> },
        {
          path: 'apply-for',
          element: <ApplyFor />,
          children: [
            { element: <Navigate to="/dashboard/apply-for/list" replace /> },
            {
              path: 'list',
              element: <ApplyForList />,
            },
            {
              path: 'edit/:id',
              element: <ApplyForEdit />,
            },
          ],
        },
        { path: 'calendar', element: <Calendar /> },
        {
          path: 'interview-panel/:id',
          element: <InterviewPanel />,
          children: [
            {
              path: 'user/:ns_user_id',
              element: null,
            },
          ],
        },
        { path: 'scanner', element: <Scanner /> },
        { path: 'token/:token', element: <AccessWithToken /> },
      ],
    },
    {
      path: 'scanner',
      element: (
        <AuthGuard>
          <Scanner />
        </AuthGuard>
      ),
    },
  ]);
};

const Login = Loadable(lazy(() => import('pages/login')));
const Dashboard = Loadable(lazy(() => import('pages/dashboard')));
const ApplyFor = Loadable(lazy(() => import('../pages/dashboard/applyFor')));
const ApplyForList = Loadable(
  lazy(() => import('../pages/dashboard/applyFor/ApplyForList'))
);
const ApplyForEdit = Loadable(
  lazy(() => import('../pages/dashboard/applyFor/ApplyForEdit'))
);
const Calendar = Loadable(lazy(() => import('../pages/dashboard/Calendar')));
const InterviewPanel = Loadable(
  lazy(() => import('../pages/dashboard/InterviewPanel'))
);
const AccessWithToken = Loadable(
  lazy(() => import('../pages/dashboard/AccessWithToken'))
);

const Scanner = Loadable(lazy(() => import('../pages/dashboard/Scanner')));

const DashboardLayout = Loadable(lazy(() => import('layout/dashboard')));
export default Routes;
